<template lang="pug">
b-autocomplete(
  v-model="settings.query"
  :data="results"
  :loading="settings.searching"
  :placeholder="placeholder"
  field="title"
  @input="getResults"
  @select="selectResult"
  icon="magnify"
  rounded
)
  template(slot="empty")
    span No matches
  template(slot-scope="props")
    .search__result.media(:class="layout")
      .media-left
        cl-img(
          :cl-id="props.option.artwork.cl_id"
          :transform="{ width: 136, height: 77 }"
        )
        //- img.image.is-32x32(src="https://bulma.io/images/placeholders/64x64.png")
      .media-content
        .level
          .level-left
            .level-item
              b {{ props.option.title }}
          .level-right
            .level-item {{ props.option.pub_date | date(dateFormat) }}
            .level-item(v-if="layout === 'regular'") {{ props.option.speaker.full_name }}
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { SEARCH } from '@/utils/http';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'episode-typeahead',
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      channels: getterTypes.GET_CHANNELS,
    }),
    channelIds() {
      return this.channels.map(c => c.id);
    },
    dateFormat() {
      return this.layout === 'regular' ? 'dddd MMMM D, YYYY' : 'MMM D, YYYY';
    },
  },
  created() {
    if (this.channelFilter !== undefined) {
      this.$store.dispatch(actionTypes.DO_GET_CHANNELS, { filter: this.channelFilter });
    }
  },
  data() {
    return {
      settings: {
        searching: false,
        query: null,
      },
      results: [],
      selected: {},
    };
  },
  methods: {
    async getResults(val) {
      const self = this;
      if (!_.isEmpty(val)) {
        this.settings.searching = true;
        const { data } = await SEARCH.post('/doxa_episodes/_search', {
          suggest: {
            suggestions: {
              text: val,
              completion: {
                field: 'suggest',
                contexts: {
                  account_id: this.account.id,
                  channel_ids: this.channelIds,
                },
              },
            },
          },
        });
        const { options } = data.suggest.suggestions[0];
        if (options.length > 0) {
          const sources = options.map(o => o._source);
          const filteredSources = _.filter(sources, s => this.validSearchResult(s));
          self.results = filteredSources.sort((a, b) => {
            const dateA = new Date(a.pub_date);
            const dateB = new Date(b.pub_date);
            return dateB - dateA;
          });
          this.settings.searching = false;
        } else {
          self.results = [];
          this.settings.searching = false;
        }
      }
    },
    selectResult(obj) {
      if (obj !== null) {
        this.$router.push({ name: 'episode', params: { id: obj.id } });
      }
    },
    validSearchResult(obj) {
      if (!obj.is_published) return false;
      const isPublished = obj.is_published && moment().isSameOrAfter(obj.pub_date);
      const isChannel = _.intersection(obj.channel_ids, this.channelIds).length > 0;
      return isPublished && isChannel;
    },
  },
  props: {
    channelFilter: {
      type: String,
      default: 'services',
    },
    placeholder: {
      type: String,
      default: 'Search...',
    },
    layout: {
      type: String,
      default: 'regular',
    },
  },
};
</script>

<style lang="scss">
.autocomplete {
  input[type="text"] {
    // border: none;
    // background-color: transparent;
  }
}
.search__result.media {
  align-items: center;
  .image {
    max-width: 68px;
  }
  &.compressed {
    .level {
      flex-flow: column;
      align-items: left;
    }
  }
  .level-right {
    color: $theme-grey;
  }
}
@media (max-width: $tablet) {
  .search__result.media {
    .image {
      max-width: 82px;
    }
    .level-item {
      justify-content: flex-start;
    }
    .level-item:not(:last-child) {
      margin-bottom: 0;
    }
    .level-left + .level-right {
      margin-top: 0;
    }
  }
}
</style>
